import 'arrive';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive('.block-carte-carburante', { existing: true }, function (el) {
    // Evita di inizializzare l'animazione più volte sullo stesso elemento
    if (el.dataset.carteCarburanteInitialized) {
        return;
    }
    el.dataset.carteCarburanteInitialized = 'true';

    const label = el.querySelector('.block-carte-carburante__label');
    const title = el.querySelector('.block-carte-carburante__title');
    const carousel = el.querySelector('.block-carte-carburante__carousel');
    const cards = gsap.utils.toArray('.block-carte-carburante__carousel .card', el);

    if (!label || !title || !carousel || cards.length === 0) {
        return;
    }

    // Imposta lo stato iniziale degli elementi per l'animazione di ingresso
    gsap.set([label, title, carousel], {
        opacity: 0,
        y: 50, // Sposta gli elementi in basso per l'effetto "fade in up"
    });

    // Prima card visibile normalmente
    gsap.set(cards[0], {
        opacity: 1,
        scale: 1,
        y: 0,
    });

    // Tutte le successive partono nascoste in basso
    gsap.set(cards.slice(1), {
        opacity: 1,
        scale: 1,     // niente riduzione scala
        y: 500,       // partono più in basso
    });

    // Crea una timeline per la sola animazione delle card, controllata dallo scroll
    const cardsTimeline = gsap.timeline();

    // Aggiungi l'animazione in sequenza delle card alla timeline
    cards.forEach((card, index) => {
        if (index === cards.length - 1) return;

        const nextCard = cards[index + 1];

        cardsTimeline
            .to({}, { duration: index === 0 ? 5 : 2 }) 
            // Uscita card corrente
                .to(card, {
                scale: 0.9,
                opacity: 0,
                ease: 'power2.inOut',
                duration: 1.2
            })
            // Entrata card successiva (sale dal basso)
            .to(nextCard, {
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                duration: 1.5
            }, "<") // "<" = parte subito dopo l'uscita della precedente
            // Pausa lunga: più scroll per leggere la card
            .to({}, { duration: 3 }); // aumenta questo valore per rallentare ancora di più
    });


    // Crea lo ScrollTrigger che gestisce il pinning e le animazioni
    ScrollTrigger.create({
        trigger: el,
        start: 'top 12px',
        end: () => `+=${cards.length * 1500}`, // più lungo rispetto ai 500 iniziali
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        animation: cardsTimeline,
        onEnter: () => {
            gsap.to([label, title, carousel], {
                opacity: 1,
                y: 0,
                stagger: 0.2,
                duration: 0.8,
                ease: 'power2.out',
            });
        },
        onLeaveBack: () => {
            gsap.to([label, title, carousel], {
                opacity: 0,
                y: 50,
                duration: 0.4,
                ease: 'power2.in',
            });
        }
    });
});
